import { render, staticRenderFns } from "./RecruitmentDetails.vue?vue&type=template&id=607a65e4&scoped=true"
import script from "./RecruitmentDetails.vue?vue&type=script&lang=js"
export * from "./RecruitmentDetails.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentDetails.vue?vue&type=style&index=0&id=607a65e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a65e4",
  null
  
)

export default component.exports